import { environment } from '@env';

/**
 * Whether the app runs embedded in the platform shell (hub-ops). The shell
 * stamps `__platform__` / `__platformHost__` on `window` before loading
 * remotes — the same detection `main.ts` uses to pick custom-element vs
 * standalone bootstrap.
 */
export function isEmbeddedInPlatformShell(): boolean {
  const win = window as unknown as Record<string, unknown>;
  return !!win['__platform__'] || win['__platformHost__'] === true;
}

/**
 * Platform-shell base URL for the current runtime. Embedded, the page origin
 * IS the platform origin (the shell mounted us on its own page), so derive it
 * from `location` — `environment.PLATFORM_URL` points at the deployed platform
 * (e.g. platform.<env>.example.com) and would fail the kit header's origin gate
 * under a locally-served shell, hiding the OL-Hub brand mark and mis-targeting
 * app-switcher links. Standalone, the static environment value is the only
 * thing we have.
 */
export function resolvePlatformUrl(): string {
  return isEmbeddedInPlatformShell() ? window.location.origin : environment.PLATFORM_URL;
}
